<div class="login-credentials-field">
    <div class="title">Select attributes, enter text or add <span class="text-italic">function</span> to create your
        custom email/username format **:
    </div>
    <ngc-chips-autocomplete-form-control [control]="entityLoginCredentialsFormGroup?.controls.email"
                                         [selectedItems]="selectedOptionsObj?.email"
                                         [allItems]="availableEmailOptions"
                                         [label]="'Select attributes, add text or function'"
                                         [placeholder]="'Enter attribute name, text or add function'"
                                         [allowToDuplicateAllValue]="true"
                                         [editable]="true"
                                         [isLoginCredentials]="true"
                                         (changeSelectedItems)="onChangeSelectedEmailOptions($event)"
                                         (editChip)="onEditChip($event, EMAIL)"
    >
    </ngc-chips-autocomplete-form-control>

    <mat-error class="login-credentials-username-field-error"
               *ngIf="entityLoginCredentialsFormGroup?.controls.email?.errors?.required && entityLoginCredentialsFormGroup?.controls.email.touched">
        {{FIELD_IS_REQUIRED_MESSAGE}}
    </mat-error>

    <mat-error class="login-credentials-username-field-error" *ngIf="!entityLoginCredentialsFormGroup?.controls.email?.errors?.required
                       && entityLoginCredentialsFormGroup?.controls.email?.errors?.usernameContainOnlyAllowedCharactersError"
    >
        {{USERNAME_MAY_CONTAIN_CHARACTERS_MESSAGE}}
    </mat-error>
    <mat-error class="login-credentials-username-field-error" *ngIf="!entityLoginCredentialsFormGroup?.controls.email?.errors?.required
                       && entityLoginCredentialsFormGroup?.controls.email?.errors?.containNotAllowedCharactersError"
    >
        {{USERNAME_CONTAIN_NOT_ALLOWED_CHARACTERS_MESSAGE}}
    </mat-error>
    <mat-error class="login-credentials-username-field-error" *ngIf="!entityLoginCredentialsFormGroup?.controls.email?.errors?.required
                       && entityLoginCredentialsFormGroup?.controls.email?.errors?.containDoublePeriodsError"
    >
        {{USERNAME_DOUBLE_PERIODS_MESSAGE}}
    </mat-error>
    <mat-error class="login-credentials-username-field-error" *ngIf="!entityLoginCredentialsFormGroup?.controls.email?.errors?.required
                       && entityLoginCredentialsFormGroup?.controls.email?.errors?.beginOrEndWithPeriodError"
    >
        {{USERNAME_BEGIN_END_PERIOD_MESSAGE}}
    </mat-error>

    <div class="info secondary-text font-weight-500">Email Example: {{templateResultsObj?.email}}</div>
</div>

<div class="login-credentials-field">
    <div class="title">Chose a domain you want to use for {{task | ngcEntityTitle: eduToneDS: integration}}:</div>
    <mat-form-field>
        <mat-select label="Choose a domain" [placeholder]="'Enter a domain'"
                    (selectionChange)="onChangeDomain($event.value)"
                    [formControl]="entityLoginCredentialsFormGroup?.controls.domain"
        >
            <mat-option [value]="dataSourceConfigDomain">{{dataSourceConfigDomain}}</mat-option>
        </mat-select>
    </mat-form-field>
    <div class="info secondary-text font-weight-500">Domain Example: {{templateResultsObj?.domain}}</div>
</div>

<div class="login-credentials-field">
    <div class="title">Select a password format you want to use
        for {{task | ngcEntityTitle: eduToneDS: integration}}:
    </div>
    <ngc-chips-autocomplete-form-control [control]="entityLoginCredentialsFormGroup?.controls.password"
                                         [selectedItems]="selectedOptionsObj?.password"
                                         [allItems]="availablePasswordOptions"
                                         [label]="'Select attributes, add text or function'"
                                         [placeholder]="'Enter attribute name, text or add function'"
                                         [editable]="true"
                                         [isLoginCredentials]="true"
                                         (changeSelectedItems)="onChangeSelectedPasswordOptions($event)"
                                         (editChip)="onEditChip($event, PASSWORD)"
    >
    </ngc-chips-autocomplete-form-control>
    <div class="info secondary-text font-weight-500">Password
        example: {{hidePasswordExample ? '**********' : templateResultsObj?.password}}
        <mat-icon matSuffix
                  class="hide-password-icon"
                  (click)="hidePasswordExample = !hidePasswordExample"
                  [matTooltip]="hidePasswordExample ? 'Show password' : 'Hide password'"
                  [matTooltipShowDelay]="700"
        >
            {{hidePasswordExample ? 'visibility_off' : 'visibility'}}
        </mat-icon>
    </div>
</div>

<span class="secondary-text mat-caption font-weight-500">
    ** To eliminate duplication by email/username an extra symbol (e.g. 1 or 2) will be added.
</span>
